import { render } from "./HeaderAcc.vue?vue&type=template&id=779c2b71"
import script from "./HeaderAcc.vue?vue&type=script&lang=js"
export * from "./HeaderAcc.vue?vue&type=script&lang=js"

import "./HeaderAcc.vue?vue&type=style&index=0&id=779c2b71&lang=less"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__